import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';

export class ChangePassword extends Component {
    displayName = ChangePassword.name

    constructor(props) {
        super(props);
        this.state = {
            user: {
                curpassword: '',
                newpassword: '',
                cnfmpassword: ''               
            },
            errors: {},
            message : "",
            submitted: false
        };
        this.handleChange = this.handleChange.bind(this);      
        this.handleConfirmPwd = this.handleConfirmPwd.bind(this);
        this.handleChangePwd = this.handleChangePwd.bind(this);
    }

    validateForm() {

        let fields = this.state.user;
        let errors = {};
        let formIsValid = true;

        if (!fields["curpassword"]) {
            formIsValid = false;
            errors["curpassword"] = "* Required field";
        }

        if (!fields["newpassword"]) {
            formIsValid = false;
            errors["newpassword"] = "* Required field";
        }
        else if (fields["curpassword"] == fields["newpassword"]) {
            formIsValid = false;
            errors["newpassword"] = "* current password and new password can not be same.";
        }
        else if (typeof fields["newpassword"] !== "undefined") {
            if (!fields["newpassword"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()+-]).*$/)) {
                formIsValid = false;
                errors["newpassword"] = "* Password must be 8 characters long and contain one capital letter, one small letter, one number and one special character (!@#$%^&*-=_+).";
            }
        }       

        if (!fields["cnfmpassword"]) {
            formIsValid = false;
            errors["cnfmpassword"] = "* Required field";
        }

        else if (fields["cnfmpassword"] != fields["newpassword"]) {
            formIsValid = false;
            errors["cnfmpassword"] = "* Password entries do not match; please re-enter.";
        }
        else if (typeof fields["cnfmpassword"] !== "undefined") {
                if (!fields["cnfmpassword"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()+-]).*$/)) {
                    formIsValid = false;
                    errors["cnfmpassword"] = "* Password must be 8 characters long and contain one capital letter, one small letter, one number and one special character (!@#$%^&*-=_+).";
                }
            }

            this.setState({
                errors: errors
            });
            return formIsValid;
        }

    handleConfirmPwd(evt) {
            let errors = {};
            if (evt.target.value != this.state.newpassword) {                
                errors["cnfmpassword"] = "* Password entries do not match; please re-enter.";                
            }
            else {
                errors["cnfmpassword"] = "";                
        }
        //this.setState({  errors: errors});
    }

    handleChangePwd(evt) {

        if (this.validateForm()) {

            var params = {
                Password: this.state.user.curpassword, NewPassword: this.state.user.newpassword, cnfmpassword: this.state.user.cnfmpassword
            }
            var self = this;
            userService.postData('User/ChangePassword', params)
                .then(function (data) {
                    self.setState({ message: data });  
                    alert(data);
                    if (data != "") {                       
                        self.setState({
                            user: {
                                curpassword: '',
                                newpassword: '',
                                cnfmpassword: ''
                            }
                        });
                    }
                });           
        }
        
    }

    handleChange(event) {        
        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }
             
    render() {
        const { user, submitted } = this.state;

        const meta = {
            title: "Kluwer Law Online - Change password"
        }
        return (
            <DocumentMeta {...meta}>
            <div className="col-12 klo-shopshopping-cart">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <div id="yourDetails" className="mt-3" >                           
                            <div className="col-sm-12 row">
                                <div className="col">
                                    <div className="row">
                                        <form style={{width:'55%'}}>
                                            <h4 className="my-3 green-heading" style={{ fontSize: '17px' }}>Change Password</h4>

                                            <div className="form-group mt-3 col-6 px-0">
                                                <label for="curpassword">Current Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="Current Password" id="curpassword" name="curpassword" value={user.curpassword} onChange={this.handleChange} />                                                
                                                <div className="errorMsg">{this.state.errors.curpassword}</div>
                                            </div>
                                            <div className="form-group mt-3 col-6 px-0">
                                                <label for="newpassword">New Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="New Password" id="newpassword" name="newpassword" value={user.newpassword} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.newpassword}</div>
                                            </div>
                                            <div className="form-group mt-3 col-6 px-0">
                                                <label for="cnfmpassword">Confirm Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="Confirm Password" id="cnfmpassword" name="cnfmpassword" value={user.cnfmpassword} onChange={this.handleChange} />
                                                <div className="errorMsg">{this.state.errors.cnfmpassword}</div>
                                            </div>                                            
                                            <br/>                                           
                                            <br></br>
                                        </form>
                                    </div>
                                    <div className="row">
                                        <button type="button" className="btn next rounded-0" onClick={this.handleChangePwd} >Change Password</button>
                                    </div>
                                </div>

                                <div className="col-0 border-right"> </div>
                                
                            </div>
                            <div className="col-lg-12 row mb-5 mt-3 ">
                                
                                <div className="col colPadding">
                                    <img src="//klitag.scholarlyiq.com/siqpagetag.gif?js=0" height="1" width="1" border="0" hspace="0" vspace="0" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
                </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/ChangePassword.jsx